import TRBadge from './TRBadge';

export * from './TRBadge';

export default TRBadge;
